<template>
  <v-card :elevation="0" style="border: 0.5px solid #CCCCCC4D;padding:5px;background-color:#CCCCCC80">
    <center v-if="!stats"><span style="font-family:Helvetica, Arial, sans-serif;font-size:14px;">
        {{ $t('dashboard.stats.access')}}
    </span></center>
    <v-btn
        v-if="!stats && !loading"
        style="margin-top:10px"
        :color="enterpriseColor"
        @click="handleGetData"
        dark
      >
        {{ $t('common.show') }}
    </v-btn>
    <v-progress-linear
      v-if="loading"
      indeterminate
      :color="enterpriseColor"
    />
    <vue-apex-charts
      v-else-if="stats"
      :key="key"
      type="bar"
      :options="options"
      :series="series"
      :height="typeData === 'M' ? '450px' : '550px'"
    />
    <v-layout wrap>
      <v-flex xs2 style="padding: 0 10px 0 0;">
        <v-select
          v-if="stats && sources && sources.length > 0"
          :items="sources"
          v-model="selectedSource"
          label="Identificador"
          outlined
          dense
          hide-details
          item-text="Name"
          item-value="ID"
          @change="handleGetData"
        />
      </v-flex>
      <v-flex xs2 style="padding: 0 10px 0 0;">
      </v-flex>
      <v-flex xs4>
        <v-btn-toggle
          v-if="stats"
          v-model="typeData"
          borderless
          mandatory
          @change="handleGetData"
          dense
        >
          <v-btn value="M">
            <span class="hidden-sm-and-down">
              {{ $t('dashboard.stats.month') }}
            </span>
          </v-btn>
          <v-btn value="D">
            <span class="hidden-sm-and-down">
              {{ $t('dashboard.stats.day') }}
            </span>
          </v-btn>
        </v-btn-toggle>
      </v-flex>
      <v-flex xs2 style="padding: 0 10px 0 0;">
        <v-select
          v-if="stats"
          :items="years"
          v-model="year"
          dense
          hide-details
          outlined
          @change="handleGetData"
        />
      </v-flex>
      <v-flex xs2 style="padding: 0 10px 0 0;">
        <v-select
          v-if="stats && typeData === 'D'"
          :items="months"
          v-model="month"
          outlined
          dense
          hide-details
          @change="handleGetData"
        />
      </v-flex>
      </v-layout>
    <!--table v-if="stats" style="margin-top: -40px">
      <tr>
        <td width="50%" class="text-right" style="padding: 10px;">
          {{ $t('dashboard.stats.month') }}
        </td>
        <td>
          <v-switch v-model="isByDay" @change="handleChangeType" style="padding-top: 10px;" color="dtouch" />
        </td>
        <td width="50%" class="text-left" style="padding: 10px;">
          {{ $t('dashboard.stats.day') }}
        </td>
      </tr>
    </table-->
  </v-card>
</template>
<script>
  import axios from 'axios'
  import VueApexCharts from 'vue-apexcharts'
  export default {
    components: {
      VueApexCharts,
    },
    props: {
      workspaceID: {
        type: String,
        required: true,
      },
      sources: {
        type: Array,
        default: null,
      },
    },
    data: () => ({
      selectedSource: null,
      years: null,
      months: [12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
      year: null,
      month: null,
      typeData: 'M',
      isByDay: false,
      stats: null,
      loading: false,
      key: 0,
      options: {
        plotOptions: {
          bar: {
              barHeight: '80%',
            horizontal: true,
            dataLabels: {
              position: 'center', // top, center, bottom
            },
          }
        },
        colors: ['#000000'],
        dataLabels: {
            enabled: true,
            textAnchor: 'start',
            formatter: function (val) {
                return '  '.concat(val)
            },
            offsetX: -10,
            offsetY: 0,
            style: {
                fontSize: '12px',
                colors: ["#CCCCCC"]
            }
        },
        chart: {
          id: 'stats'
        },
        xaxis: {
          categories: []//[1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
        },
        title: {
          text: '',
          align: 'center',
          floating: true
        },
        subtitle: {
            text: '',
            align: 'center',
        },
      },
      series: [{
        name: 'clicks',
        data: [] // [30, 40, 45, 50, 49, 60, 70, 91]
      }]
    }),
    computed: {
      enterpriseColor() {
        return this.$vuetify.theme.currentTheme.primary
      },
      enterpriseName() {
        return ''
        //return this.$store.state.app.enterpriseName
      },
      info () {
        return process.env.VUE_APP_INFOSORT
      }
    },
    watch: {
      workspaceID (){
        if (this.stats) this.handleGetData()
      },
      sources () {
        this.selectedSource = null
      },
    },
    mounted () {
      this.prepareSelects()
      this.year = new Date().getFullYear()
      this.month = new Date().getMonth() + 1
    },
    methods: {
      prepareSelects () {
        const aux = []
        for (let i = new Date().getFullYear() ; i >= 2019; i--) {
          aux.push(i)
        }
        this.years = aux
      },
      handleChangeType() {
        //this.type = type ? 'D' : 'M'
        //this.handleGetData()
      },
      async handleGetData () {
        this.stats = null
        this.loading = true
        try {
          const baseURL = 'https://cm-dtouch-stats-api.dtouch.es'
          const year = this.year
          const month = this.month
          const params = `${year}/${this.typeData === 'D' ? month : 'NO'}/${this.selectedSource ? this.selectedSource : ''}`
          const aux = await new Promise((resolve, reject) => axios.get(`${baseURL}/v1/public/stats/access/${this.workspaceID}/${params}`)
            .then(response => {
              resolve(response.data)
            })
            .catch(error => {
              console.log(error)
              reject(error)
            }))
          this.handleConvertStats(aux.map(item => {
            return {
              key: item.Day ? item.Day.toString() : `M-${item.Month.toString()}`,
              value: parseInt(item.Count)
            }
          }))
          this.stats = aux
          this.loading = false
        } catch (error) {
          console.log(error)
          this.loading = false
        }
        /*
        this.loading = true
        let filter = []
        if (this.type === 'M') {
          for (let i = 0; i < 12; i++) {
            const date = new Date()
            date.setMonth(date.getMonth() - i)
            if (filter.indexOf(`${date.getMonth() + 1} / ${date.getFullYear()}`) < 0) filter.push(`${date.getMonth() + 1} / ${date.getFullYear()}`)
          }
        } else {
          for (let i = 0; i < 7; i++) {
            const date = new Date()
            date.setDate(date.getDate() - i)
            filter.push(`${date.getDate()} / ${date.getMonth() + 1} / ${date.getFullYear()}`)
          }
        }
        api.getAll(`stats/${this.workspaceID}/${this.type}/main`, 1, 100000, '').then(response => {
          filter = filter.map(item => {
            const aux = this.type === 'M' ?
                                response.filter(x => `${x.Month} / ${x.Year}` === item) :
                                response.filter(x => `${x.Day} / ${x.Month} / ${x.Year}` === item)
            this.loading = false
            return ({
              key: item,
              value: aux.length > 0 ? aux[0].Count : 0
            })
          })
          this.handleConvertStats(filter)
          //this.stats = filter
        })
          */
      },
      handleConvertStats (stats) {
        this.key = new Date().toISOString()//this.enterpriseName.concat('_', _.uniqueId())
        const auxData = []
        const auxCategories = []
        for (let i = 0; i < stats.length;i++) {
          auxData.push(stats[i].value)
          auxCategories.push(stats[i].key)
        }

        if (this.series) {
          this.series[0].data = auxData
        } else {
          this.series = [{
            name: 'clicks',
            data: auxData
          }]

        }
        this.options.xaxis.categories = auxCategories
        this.options.colors =[`${this.enterpriseColor.substring(0,7)}`]
        this.options.title.text = this.$t('dashboard.stats.access').concat(this.enterpriseName)
        this.options.subtitle.text = this.info
      },
    }
  }
</script>
<style>
  .v-sheet--offset {
    top: -24px;
    position: relative;
  }
</style>
